export default {
    recordDetails: {
        enableInventory: "在庫管理を有効にする",
        inventoryDisabled: "在庫管理は無効です",
        inventoryEnabled: "在庫管理を有効にしました",
        inventorySaved: "在庫調整を保存しました",
        itemTitle: "品目の詳細",
        expenseTitle: "経費の詳細",
        timeTitle: "作業時間の詳細",
        information: "詳細情報",
        receipt: "領収書",
        inventoryHistory: "在庫履歴",
        inventoryLoadFailed: "在庫履歴を読み込めませんでした。",
        noInventory: "在庫履歴はまだありません",
        loadFailed: "詳細を読み込めませんでした。",
        deleteConfirm: "この記録を削除しますか？",
        deleted: "記録を削除しました"
    },
    common: {
        appName: 'Swift Invoice',
        back: '戻る',
        cancel: 'キャンセル',
        email: 'メールアドレス',
        password: 'パスワード',
        or: 'または',
        change: '変更',
        delete: '削除',
        save: '保存',
        edit: '編集',
        add: '追加',
        close: '閉じる',
        date: '日付',
        total: '合計',
        status: 'ステータス',
        amount: '金額',
        quantity: '数量',
        rate: '単価',
        tax: '税金',
        discount: '割引',
        note: 'メモ',
        notes: 'メモ',
        noData: 'データがありません',
        description: '説明',
        client: '顧客',
        item: 'アイテム',
        items: 'アイテム',
        type: '種類',
        category: 'カテゴリー',
        phone: '電話番号',
        name: '名前',
        subject: '件名',
        saveAndClose: '保存して閉じる',
        saveAndSendEmail: '保存してメールを送信',
        sendEmail: 'メールを送信',
        send: '送信',
        print: '印刷',
        moreActions: 'その他の操作',
        preparingPdf: 'PDFを準備しています...',
        pdfPreparationFailed: 'PDFを準備できませんでした',
        warning: '警告',
        ok: 'OK',
        uploadSuccess: 'アップロード成功',
        saveSuccess: '保存成功',
        deleteSuccess: '削除成功',
        deleteFailed: '削除失敗',
        saveFailed: '保存失敗',
        loadFailed: '読み込み失敗',
        systemError: 'システムエラー',
        sendSuccess: '送信成功',
        updateSuccess: '更新成功',
        unsavedChangesMsg: '未保存の変更があります。保存しますか、破棄しますか？',
        saveChangesTitle: '変更を保存しますか？',
        confirmSave: '保存',
        discard: '破棄',
        validEmail: '有効なメールアドレスを入力してください',
        deleteFailedMsg: '削除失敗',
        shipping: '配送',
        attachment: '添付ファイル',
        days: '日',
        excl: '(税抜)',
        incl: '(税込)',
        of: '/',
        batchActions: '一括操作',
        selected: '件選択',
        select: '選択',
        batchDeleteConfirm: '選択した {count} 件を削除しますか？',
        batchActionSuccess: '{count} 件を更新しました',
        batchActionPartial: '{processed} 件を更新、{skipped} 件は変更不要です',
        batchEmailInvalidRecipients: '各書類に有効な宛先を入力してください',
        batchEmailSent: '{count} 件のメールを送信しました',
        batchEmailPartial: '{sent} 件送信、{failed} 件失敗',
        emailHtmlNotAllowed: 'メールの件名と本文に HTML は使用できません。'
    },
    emailVerification: {
        title: 'メールアドレスを確認',
        description: 'ログイン用メールアドレスに確認コードを送信しました：',
        codePlaceholder: '確認コードを入力',
        enterCode: 'メールに記載されたコードを入力してください。',
        sent: '確認コードを送信しました。',
        resent: '新しい確認コードを送信しました。',
        validFor: 'コードは10分間有効です。',
        verify: '確認',
        resend: '再送信',
        success: 'メールアドレスを確認しました。メールを送信します。',
        failed: '確認コードが正しくないか、有効期限が切れています。',
        limitReached: '本日の送信上限に達しました。',
        remaining: '本日はあと{count}回送信できます',
        contactUs: 'お問い合わせ'
    },
    login: {
        heroPrefix: 'スマートな',
        heroInvoicing: '請求書管理',
        heroMiddle: '、',
        heroSimplified: 'シンプル化',
        heroSuffix: 'をお届けします。',
        subtitle1: '請求書を簡単に作成・送信・管理できます。',
        subtitle2: 'Swift Invoice でより早く入金を受け取りましょう。',
        feature1Title: 'プロフェッショナルな請求書',
        feature1Text: '数分で美しい請求書を作成',
        feature2Title: 'リアルタイム追跡',
        feature2Text: '支払いと請求書ステータスを追跡',
        feature3Title: '安全・安心',
        feature3Text: 'エンタープライズレベルのセキュリティでデータを保護',
        welcomeBack: 'おかえりなさい',
        signInToContinue: '続行するにはアカウントにサインインしてください',
        enterEmail: 'メールアドレスを入力',
        enterPassword: 'パスワードを入力',
        rememberMe: 'ログイン情報を保存',
        forgotPassword: 'パスワードをお忘れですか？',
        signIn: 'サインイン',
        signingIn: 'サインイン中…',
        continueWithGoogle: 'Google で続行',
        continueWithApple: 'Apple で続行',
        createAccount: 'アカウント作成',
        startUsing: 'Swift Invoice を始める',
        companyName: '会社名',
        enterCompanyName: '会社名を入力してください',
        alreadyHaveAccount: 'すでにアカウントをお持ちですか？サインイン',
        footerRights: '© 2026 Swift Invoice. All rights reserved.',
        termsOfService: '利用規約',
        contactUs: 'お問い合わせ: goodinvoicego@gmail.com',
        betaDialogBody: 'チームがウェブ版の第1版を完成させました <br> このバージョンは iPhone ユーザーのみ利用可能です <br> ウェブ機能はできるだけ早く改善し、すべてのユーザーに公開予定です <br>',
        ieDialogBody: '申し訳ありません、IE ブラウザには互換性の問題があるため、現在 IE ブラウザには対応していません。ご利用の際はダウンロードしてください',
        resetPasswordTitle: 'パスワードリセット',
        sendResetEmail: 'リセットメールを送信',
        resetEmailSent: 'パスワードリセットメールを送信しました。受信箱をご確認ください。',
        bindingTitle: '既存アカウントを連携',
        bindingHintPrefix: 'このメールアドレス ',
        bindingHintSuffix: ' はすでに別のアカウントで使用されています。Google サインインを連携するには、そのアカウントのパスワードを入力してください。',
        enterAccountPassword: 'アカウントのパスワードを入力',
        linkAccount: 'アカウントを連携',
        validEmail: '有効なメールアドレスを入力してください',
        validPassword: 'パスワードは6文字以上でなければなりません',
        validCompanyName: '会社名を入力してください',
        companyNameTooLong: '会社名は最大{max}文字まで入力できます',
        turnstileUnavailable: 'セキュリティ確認を読み込めませんでした。もう一度お試しください。',
        turnstileExpired: 'セキュリティ確認の有効期限が切れました。もう一度完了してください。',
        accountDataLoadFailed: 'アカウントは確認されましたが、事業データを読み込めませんでした。もう一度お試しください。'
    },
    account: {
        title: 'アカウント',
        profile: 'プロフィール',
        swiftAccount: 'Swift Invoice アカウント',
        connectSocial: 'ソーシャルアカウントを連携',
        companyLogo: '会社ロゴ',
        logoSize: 'ロゴのサイズ',
        hideBusinessName: '事業名を非表示',
        businessNameSize: '事業名のサイズ',
        sizeSmall: '小',
        sizeNormal: '標準',
        sizeBig: '大',
        addLogo: 'ロゴを追加',
        uploading: 'アップロード中...',
        currentPlan: '現在のプラン: Swift {plan}',
        planActiveUntil: 'プラン有効期限: {date}',
        sharedWithMobile: 'モバイルと共有',
        subscriptionExpired: 'サブスクリプションの有効期限が切れています',
        planNote: 'サブスクリプションのステータスが更新されていない場合は、再度ログインしてください。',
        upgradeToPro: 'Swift Pro にアップグレード',
        viewPlans: 'サブスクリプションプランを表示',
        connecting: '連携中…',
        connectGoogle: 'Google を連携',
        googleConnected: 'Google 連携済み',
        googleConnectedWithEmail: 'Google 連携済み ({email})',
        connectApple: 'Apple を連携',
        appleConnected: 'Apple 連携済み',
        appleConnectedWithEmail: 'Apple 連携済み ({email})',
        logoUuidMissing: '会社ロゴの UUID が見つかりません',
        googleConnectedToast: 'Google アカウントが連携されました。',
        appleConnectedToast: 'Apple アカウントが連携されました。',
        logoUploadEmpty: '画像を選択してください。',
        logoUploadSize: '画像は 10 MB 以下にしてください。',
        logoUploadType: 'JPEG、PNG、BMP 画像のみ対応しています。',
        logoUploadFailed: '会社ロゴをアップロードできませんでした。',
        logoUnavailable: 'ロゴファイルを利用できません。再度アップロードしてください。',
        deleteAccount: 'アカウントを削除',
        deleteAccountDescription: 'Swift Invoice アカウントを完全に閉鎖します。',
        deleteAccountTitle: 'アカウントを削除しますか？',
        deleteAccountWarning: 'この操作は取り消せません。',
        deleteAccountConfirm: 'アカウントの削除を確認するため、パスワードを入力してください。',
        deleteAccountPasswordPlaceholder: 'パスワードを入力'
    },
    menu: {
        openNavigation: 'ナビゲーションを開く',
        closeNavigation: 'ナビゲーションを閉じる',
        invoices: '請求書',
        estimates: '見積書',
        purchaseOrders: '発注書',
        creditMemos: 'クレジットメモ',
        time: '時間',
        items: 'アイテム',
        clients: '顧客',
        expenses: '経費',
        reports: 'レポート',
        settings: '設定',
        companyInfo: '会社情報',
        taxes: '税金',
        default: 'デフォルト',
        customizeInvoice: '請求書をカスタマイズ',
        sendFeedback: 'フィードバックを送信',
        newReply: '新しい返信 1件',
        signOut: 'サインアウト',
        signOutConfirm: 'サインアウトしてもよろしいですか？',
        addBusiness: '事業を追加',
        newBusinessTitle: '新しい事業',
        businessName: '事業名',
        businessNamePlaceholder: '事業名を入力してください',
        createBusiness: '作成',
        businessNameRequired: '事業名を入力してください',
        createBusinessSuccess: '事業を作成しました',
        deleteBusiness: '会社を削除',
        deleteBusinessTitle: '会社を削除',
        deleteBusinessConfirm: '「{name}」を削除しますか？',
        deleteBusinessWarning: 'この会社に属するすべてのデータが削除されます。',
        deleteBusinessSuccess: '会社を削除しました',
        trialDaysLeft: '試用期間は残り{days}日です',
        upgradeAccount: 'アカウントをアップグレード'
    },
    network: {
        loginExpired: 'ログインの有効期限が切れました。再度ログインしてください',
        requestTimeout: 'リクエストがタイムアウトしました。ネットワークを確認してください'
    },
    language: {
        label: '言語',
        zh: '中文',
        en: 'English'
    },
    invoice: {
        listLoadFailed: '請求書を読み込めませんでした。',
        summaryLoadFailed: '請求書の集計を読み込めませんでした。',
        invoiceNumberPlaceholder: '請求書番号を入力',
        filterAllClients: 'すべての顧客',
        clientOptionsLoadFailed: '絞り込み用の顧客を読み込めませんでした。',
        filterAllStatuses: 'すべてのステータス',
        filterUnpaid: '未払い',
        filterPaid: '支払済み',
        filterOverdue: '期限超過',
        filterUnsent: '未送信',
        filterSent: '送信済み',
        filterStartDate: '開始日',
        filterEndDate: '終了日',
        searchPlaceholder: '請求書を検索',
        addInvoice: '請求書を追加',
        overdueInvoices: '期限超過の請求書',
        paidInvoices: '支払済みの請求書',
        unpaidInvoices: '未払いの請求書',
        unsentInvoices: '未送信の請求書',
        columnNumber: '番号',
        columnClient: '顧客',
        columnStatus: 'ステータス',
        statusFullyPaid: '全額支払済み',
        statusPartial: '一部支払い',
        statusOverdue: '期限超過',
        statusUnsent: '未送信',
        statusSent: '送信済み',
        statusOpened: '開封済み',
        actionRecordPayment: '支払いを記録',
        actionMarkAsSent: '送信済みにする',
        actionCopy: 'コピー',
        actionDelete: '削除',
        copyDialogTitle: '請求書をコピー',
        copyTargetType: 'コピー先',
        copyOptions: 'コピーオプション',
        copyClient: 'クライアントをコピー',
        copyItems: 'アイテムをコピー',
        copyAttachments: '添付ファイルをコピー',
        confirmDelete: 'この請求書が削除されます。続行しますか？',
        copySuccess: '請求書をコピーしました',
        copyFailed: 'コピーに失敗しました',
        deleteSuccess: '請求書を削除しました',
        deleteFailed: '削除に失敗しました',
        recordPaymentDialogTitle: '支払いを記録',
        markAsFullyPaid: '全額支払済みにする',
        formAmount: '金額',
        formDate: '日付',
        formPaymentMethod: '支払い方法',
        formNote: 'メモ',
        allYears: 'すべての年',
        errorNoOutstandingBalance: '支払い可能な未払い残高がありません',
        errorInvalidPaymentAmount: '0より大きく、小数点以下5桁以内の金額を入力してください',
        dueDateToday: '今日',
        dueDateDaysAgo: '{days}日前',
        dueDateInDays: '{days}日後'
    },
    estimate: {
        filterAllStatuses: 'すべてのステータス',
        pageTitlePurchaseOrders: '発注書',
        pageTitleEstimates: '見積書',
        pageTitleCreditMemos: 'クレジットメモ',
        searchPlaceholderPurchaseOrders: '発注書を検索',
        searchPlaceholderEstimates: '見積書を検索',
        searchPlaceholderCreditMemos: 'クレジットメモを検索',
        addPurchaseOrder: '発注書を追加',
        addEstimate: '見積書を追加',
        addCreditMemo: 'クレジットメモを追加',
        columnNumber: '番号',
        columnClient: '顧客',
        columnDate: '日付',
        columnEmail: 'メールアドレス',
        columnStatus: 'ステータス',
        columnTotal: '合計',
        statusUnsent: '未送信',
        statusSent: '送信済み',
        actionMarkAsSent: '送信済みにする',
        actionCopy: 'コピー',
        actionDelete: '削除',
        actionConvertToInvoice: '請求書に変換',
        copyDialogTitle: '{document}をコピー',
        copyTargetType: 'コピー先',
        copyOptions: 'コピーオプション',
        copyClient: 'クライアントをコピー',
        copyItems: 'アイテムをコピー',
        copyAttachments: '添付ファイルをコピー',
        confirmDelete: 'この{document}が削除されます。続行しますか？',
        convertConfirm: 'この{document}を請求書に変換しますか？日付は今日に設定されます。',
        copySuccess: '{document}をコピーしました',
        copyFailed: 'コピーに失敗しました',
        convertSuccess: '{document}を請求書に変換しました',
        convertFailed: '変換に失敗しました',
        deleteSuccess: '{document}を削除しました',
        deleteFailed: '削除に失敗しました',
        dueDateToday: '今日',
        dueDateDaysAgo: '{days}日前',
        dueDateInDays: '{days}日後'
    },
    item: {
        pageTitle: 'アイテム',
        searchPlaceholder: 'アイテムを検索',
        addItem: 'アイテムを追加',
        columnInventoryCountUnit: '在庫数/単位',
        noDescription: '品目の説明はありません'
    },
    client: {
        detailsTitle: '顧客詳細',
        contactDetails: '連絡先',
        invoiceHistory: '請求書履歴',
        noInvoices: '請求書はまだありません',
        retry: '再試行',
        detailsLoadFailed: '顧客詳細を読み込めませんでした。',
        invoicesLoadFailed: '請求書を読み込めませんでした。',
        deleteConfirm: 'この顧客を削除しますか？',
        deleted: '顧客を削除しました',
        pageTitle: '顧客',
        searchPlaceholder: '顧客を検索',
        addClient: '顧客を追加',
        columnClientName: '顧客名',
        columnEmail: 'メールアドレス',
        columnPhone: '電話番号',
        columnBalanceDue: '未払残高',
        noNameFallback: '名前なし'
    },
    expense: {
        pageTitle: '経費',
        searchPlaceholder: '経費を検索',
        allCategories: 'すべてのカテゴリ',
        noCategory: 'カテゴリなし',
        categoryLoadFailed: '経費カテゴリを読み込めませんでした。',
        addExpense: '経費を追加',
        columnDescription: '説明',
        columnDate: '日付',
        columnTotal: '合計',
        tip: 'チップ'
    },
    report: {
        headerTitle: 'レポート',
        tabDashboard: 'ダッシュボード',
        tabReportList: 'レポート一覧',
        export: 'エクスポート',
        annualSalesByClient: '顧客別年間売上',
        otherClients: 'その他の顧客',
        totalOutstandingBalance: '未払残高合計',
        invoicesCountSuffix: '件の請求書',
        byMonth: '月別',
        byQuarter: '四半期別',
        noSalesFound: '売上が見つかりません',
        filterReportTypes: 'レポート種別',
        filterTimePeriod: '期間',
        filterView: '表示',
        filterTaxYear: '税務年度',
        filterQuarter: '四半期',
        filterMonth: '月',
        filterStartDate: '開始日',
        filterEndDate: '終了日',
        invalidCustomDateRange: '開始日は終了日より後にできません',
        searchClientName: '顧客名を検索',
        searchItemName: '商品名を検索',
        searchSalesJournal: '請求書番号または顧客名を検索',
        searchPaymentsJournal: '請求書番号、顧客名、支払方法を検索',
        periodMonth: '月',
        periodQuarter: '四半期',
        periodYear: '年',
        periodAllTaxYears: 'すべての税務年度',
        periodCustom: 'カスタム',
        taxYearLabel: '税務年度 {year}',
        quarterLabel: '税務年度 {year} Q{quarter}',
        optionMonthly: '月次',
        optionQuarterly: '四半期',
        customerAgingTitle: '顧客エイジング',
        noDataForDateRange: 'この期間のデータはありません',
        typeSalesByDate: '日別売上',
        typeSalesByClient: '顧客別売上',
        typeSalesByItem: 'アイテム別売上',
        typeSalesJournal: '売上仕訳帳',
        typePaymentsByDate: '日別支払い',
        typePaymentsByClient: '顧客別支払い',
        typePaymentsByType: '種類別支払い',
        typePaymentsJournal: '支払い仕訳帳',
        typeExpenseByCategory: 'カテゴリー別経費',
        typeExpenseJournal: '経費仕訳帳',
        typeProfitLoss: '損益',
        typeTaxes: '税金',
        typeCustomerAging: '顧客エイジング',
        allYears: 'すべての年',
        allTime: '全期間',
        allSales: '全売上',
        taxYearSales: '会計年度 {year} 売上',
        firstColumnMonth: '月',
        firstColumnQuarter: '四半期',
        firstColumnYear: '年',
        firstColumnDay: '日',
        firstColumnDate: '日付',
        columnSubTotal: '小計',
        columnTax: '税金',
        columnDiscount: '割引',
        columnTotal: '合計',
        columnAmountPaid: '支払済額',
        columnAmountOwed: '未払額',
        columnClient: '顧客',
        columnItem: 'アイテム',
        columnUnitType: '単位の種類',
        columnQuantity: '数量',
        columnRateAvg: '単価 (平均)',
        columnInvoiceDate: '請求日',
        columnInvoiceNo: '請求書番号',
        columnType: '種類',
        columnPaymentDate: '支払日',
        columnCategory: 'カテゴリー',
        columnExpenseDate: '経費日',
        columnMerchant: '加盟店',
        columnDescription: '説明',
        columnCurrentDue: '現在の未払額',
        column1To30DaysOverdue: '1〜30日期限超過',
        column31To60DaysOverdue: '31〜60日期限超過',
        column61To90DaysOverdue: '61〜90日期限超過',
        column91PlusDaysOverdue: '91日以上期限超過',
        columnSection: '区分',
        columnAmount: '金額',
        columnPreTaxSales: '税引前売上',
        columnTaxLabel: '税名',
        columnTaxRate: '税率',
        columnTotalTax: '税額合計',
        columnPostTaxTotal: '税込合計',
        profitLossTitle: '損益',
        taxesTitle: '税金',
        profitLossRevenue: '収益',
        profitLossExpense: '経費',
        profitLossProfit: '利益',
        profitLossCash: '現金',
        profitLossAccrued: '発生主義',
        profitLossAccountsReceivables: '売掛金',
        profitLossNone: '[なし]',
        profitLossTotalExpenses: '経費合計',
        profitLossCashProfit: '現金利益',
        profitLossAccruedProfit: '発生主義利益',
        monthNames: '1月, 2月, 3月, 4月, 5月, 6月, 7月, 8月, 9月, 10月, 11月, 12月',
        totalRowLabel: '合計'
    },
    invoiceCreate: {
        pageTitlePrefix: '追加',
        initialDataLoadFailed: '書類設定を読み込めませんでした。編集と保存は無効です。',
        searchSuggestionsLoadFailed: '検索候補を読み込めませんでした。',
        invoicePrefix: '請求書プレフィックス',
        tabCreate: '作成',
        tabPreview: 'プレビュー',
        tabSendEmail: 'メール送信',
        sectionClient: '顧客',
        addClient: '顧客を追加',
        dialogClientInfo: '顧客情報',
        basicInformation: '基本情報',
        labelName: '名前',
        labelEmail: 'メールアドレス',
        labelPhone: '電話番号',
        billingAddress: '請求先住所',
        labelLine1: '住所1',
        labelLine2: '住所2',
        labelLine3: '住所3',
        shippingAddress: '配送先住所',
        labelShippingName: '配送先名',
        labelNotes: 'メモ',
        placeholderCreateOrSelect: '作成または選択...',
        placeholderClientNotes: '顧客に関するメモを追加します。顧客には表示されません',
        sectionItems: 'アイテム',
        saveToYourItem: 'アイテムとして保存',
        stock: '在庫:',
        placeholderItemCode: 'アイテムコード',
        placeholderQuantity: '数量',
        placeholderRate: '単価',
        placeholderInputDescription: '説明を入力',
        placeholderInputComment: 'コメントを入力',
        placeholderAddRecipient: '受信者を追加',
        cc: 'Cc',
        bcc: 'Bcc',
        placeholderEmailSubject: 'メール件名',
        placeholderMessage: 'メッセージを入力...',
        labelTo: '宛先',
        labelSubject: '件名',
        sectionAttachments: '添付ファイル',
        sectionComment: 'コメント',
        addItem: 'アイテムを追加',
        addPhoto: '写真を追加',
        addPayment: '支払いを追加',
        goBack: '戻る',
        dialogShippingInfo: '配送情報',
        dialogRecordPayment: '支払いを記録',
        dialogJobDetails: 'ジョブ詳細',
        labelAmount: '金額',
        labelShipDate: '発送日',
        labelShipVia: '配送業者',
        labelTrackingNumber: '追跡番号',
        labelFob: 'FOB',
        columnDate: '日付',
        columnType: '種類',
        msgClientEmailError: '顧客のメールアドレスエラー',
        msgAmountGreaterThanZero: '金額は0より大きくしてください',
        msgInvalidAmount: '金額は 0 以上 999,999,999,999,999 以下で、小数点以下は5桁までです',
        calculatedAmountOutOfRange: '計算後の金額が対応範囲を超えています',
        msgTextTooLong: '{field}は{max}文字以内で入力してください',
        msgTextTooLongBytes: '{field}はUTF-8で{max}バイト以内にしてください',
        msgInvalidJobDetails: '作業詳細に無効なデータが含まれています',
        msgMorePaymentThanBalance: '未払残高より多くの支払いが入力されています',
        mailSentSuccessfully: 'メールの送信に成功しました',
        cumulativeTaxNotice: 'ウェブ版では請求書の税金の累算には対応していません...',
        confirmUnsavedChanges: '未保存の変更があります。保存しますか、破棄しますか？',
        pdf: 'PDF',
        taxDiscountWithholding: '税金、割引、源泉徴収',
        purchaseOrder: '発注書',
        placeholderPurchaseOrderPrefix: '発注書プレフィックス',
        placeholderCreditMemoPrefix: 'クレジットメモのプレフィックス',
        placeholderEstimatePrefix: '見積書プレフィックス',
        labelStatus: 'ステータス',
        statusIssued: '発行済み',
        statusApproved: '承認済み',
        statusPending: '保留中',
        statusWithdrawn: '取り下げ',
        tax: '税金'
    },
    createEstimate: {
        pageTitlePrefix: '追加',
        cumulativeTaxNotice: 'ウェブ版では見積書の税金の累算には対応していません...'
    },
    updateInvoice: {
        pageTitlePrefix: '更新',
        deletePrefix: '削除',
        confirmDelete: 'この請求書が削除されます。続行しますか？',
        cumulativeTaxNotice: 'この請求書には累算税金が含まれています。ウェブ版は現在この機能に対応していません'
    },
    updateEstimate: {
        pageTitlePrefix: '更新',
        deletePrefix: '削除',
        confirmDelete: 'この{document}が削除されます。続行しますか？',
        cumulativeTaxNotice: 'この見積書には累算税金が含まれています。ウェブ版は現在この機能に対応していません'
    },
    createAccount: {
        title: 'アカウント作成',
        placeholderEmail: 'メールアドレス',
        placeholderPassword: 'パスワード',
        placeholderCompanyName: '会社名',
        createAccountButton: 'アカウント作成',
        alreadyHaveAccount: 'すでにアカウントをお持ちですか？',
        signIn: 'サインイン',
        validEmail: '有効なメールアドレスを入力してください',
        validPassword: 'パスワードは6文字以上でなければなりません',
        validCompanyName: '会社名を入力してください',
        companyNameTooLong: '会社名は最大{max}文字まで入力できます'
    },
    clientCreate: {
        pageTitle: '顧客を追加',
        basicInformation: '基本情報',
        labelName: '名前',
        placeholderName: '名前を入力...',
        labelEmail: 'メールアドレス',
        placeholderEmail: 'メールアドレスを入力...',
        labelPhone: '電話番号',
        placeholderPhone: '電話番号を入力...',
        billingAddress: '請求先住所',
        labelLine1: '住所1',
        labelLine2: '住所2',
        labelLine3: '住所3',
        shippingAddress: '配送先住所',
        sameAsBilling: '請求先住所と同じ',
        labelShippingName: '配送先名',
        labelShippingLine1: '住所1',
        labelShippingLine2: '住所2',
        labelShippingLine3: '住所3',
        labelNotes: 'メモ',
        placeholderNotes: '顧客に関するメモを追加します。顧客には表示されません',
        defaultDiscount: 'デフォルト割引',
        validDefaultDiscount: '有効なデフォルト割引を入力してください',
        validName: '顧客名を入力してください',
        validEmail: '有効なメールアドレスを入力してください'
    },
    clientUpdate: {
        pageTitle: '顧客を更新',
        confirmDelete: 'この顧客が削除されます。続行しますか？'
    },
    itemCreate: {
        pageTitle: 'アイテムを追加',
        itemTitle: 'アイテム',
        labelCost: '原価',
        rateSign: '単価の符号',
        inventorySign: '在庫調整の符号',
        labelUnit: '単位',
        placeholderUnit: '単位',
        defaultTaxes: 'デフォルト税金',
        taxOff: 'オフ',
        inventoryTitle: '在庫',
        currentInventory: '現在の在庫',
        adjustInventory: '在庫を調整',
        increase: '増加',
        decrease: '減少',
        placeholderQuantity: '数量',
        placeholderDateAndTime: '日時',
        placeholderNote: 'メモ',
        addButton: '追加',
        columnDate: '日付',
        columnQuantity: '数量',
        columnNote: 'メモ',
        withholdingTitle: '源泉徴収',
        msgInventoryCannotDisable: '在庫機能は一度有効にすると無効にできません',
        msgDescriptionRequired: '商品説明は必須です',
        msgInvalidRate: '単価は -999,999,999,999,999 から 999,999,999,999,999 の範囲で、小数点以下は4桁以内にしてください',
        msgInvalidCost: '原価は 0 から 999,999,999,999,999 の範囲で、小数点以下は5桁以内にしてください',
        msgInvalidInventory: '数量は 0 から 999,999,999,999,999 の範囲で、小数点以下は5桁以内にしてください',
        msgInvalidUnit: '単位には && を含めず、255文字以内にしてください',
        msgQuantityRequired: '数量は必須です',
        msgDateRequired: '日時は必須です'
    },
    itemUpdate: {
        pageTitle: 'アイテムを編集',
        columnInvoice: '請求書',
        confirmDelete: 'このアイテムが削除されます。続行しますか？'
    },
    createStatement: {
        pageTitle: '明細書',
        tabPreview: 'プレビュー',
        tabSendEmail: 'メール送信',
        createAction: '明細書を作成',
        from: '開始',
        to: '終了',
        invoices: '請求書',
        balanceDue: '未払い残高',
        editTitle: '明細書を編集',
        startDate: '開始日',
        endDate: '終了日',
        onlyShowUnpaid: '未払いの請求書のみ表示',
        unpaidOnlyActive: 'この明細書には未払いの請求書のみが含まれます。',
        dateRequired: '開始日と終了日は必須です',
        invalidDateRange: '終了日は開始日より前にできません'
    },
    time: {
        pageTitle: '工数',
        unbilled: '未請求',
        billed: '請求済み',
        searchPlaceholder: '顧客名または説明で工数を検索',
        addTime: '工数を追加',
        noTime: '工数記録がありません',
        noTimeDescription: '請求可能な作業を記録する工数を作成します。',
        noClient: '顧客なし',
        filterAndSort: '絞り込みと並べ替え',
        year: '年',
        groupBy: 'グループ化',
        sortBy: '並べ替え',
        order: '順序',
        yearly: '年別',
        quarterly: '四半期別',
        monthly: '月別',
        ascending: '昇順',
        descending: '降順',
        duration: '時間',
        createTitle: '工数を作成',
        editTitle: '工数',
        selectClient: '顧客を選択',
        start: '開始',
        end: '終了',
        hours: '時間',
        minutes: '分',
        ratePreset: '単価',
        customRate: 'カスタム単価',
        rateName: '単価名',
        showRateName: '請求書に単価名を表示',
        invalidDate: '開始時刻と終了時刻は必須です',
        endBeforeStart: '終了時刻を開始時刻より前にすることはできません',
        invalidDuration: '時間は開始時刻と終了時刻に一致する必要があります',
        invalidRate: '単価は 0〜999999999999999 の範囲で、小数点以下5桁以内にしてください',
        rateNameTooLong: '単価名は255文字以内にしてください',
        descriptionTooLong: '説明は3000文字以内にしてください',
        confirmDelete: 'この工数記録を削除します。続行しますか？'
    },
    setting: {
        taxInfo: '税金情報',
        taxes: '税金',
        taxYearStarts: '会計年度の開始',
        taxYearStartSubtitle: '会計年度の最初の日を設定',
        rateLabel: '税率(%)',
        abbreviation: '略称',
        addTax: '税金を追加',
        month: '月',
        day: '日',
        monthPlaceholder: '月',
        dayPlaceholder: '日',
        saveTaxYearStart: '保存',
        deleteDialogTitle: '削除',
        confirmDeleteTax: 'この税金を削除してもよろしいですか？',
        deleteConfirm: '削除',
        taxInfoDialogTitle: '税金情報',
        taxName: '税名',
        standardRate: '標準税率 (%)',
        additionalRate: '追加税率',
        deleteRateX: 'X',
        addRate: '税率を追加',
        taxType: '税の種類',
        exclusive: '税抜',
        inclusive: '税込',
        close: '閉じる',
        saveTax: '税金を保存',
        cantOpenDetailMessage: 'この税金には累算税金が含まれています。ウェブ版は現在この機能に対応していません',
        closeButton: '閉じる',
        rateIsRequired: '税率は必須です',
        rateIsRequiredMsg: '税率は必須です',
        monthAndDayRequired: '月と日は必須です',
        additionalRateNumber: '追加税率 {number} (%)',
        taxNameRequired: '税名は必須です',
        invalidTaxRate: '税率は 0〜999999999999999 の範囲で、小数点以下4桁以内にしてください',
        duplicateTaxRate: '税率は重複できません',
        taxRatesTooLong: '税率が多すぎるため保存できません',
        withholdingNameRequired: '源泉徴収を有効にする場合は略称が必須です',
        moreRate: '件の追加税率',
        moreRates: '件の追加税率'
    },
    companyInfo: {
        title: '会社情報',
        details: '詳細',
        businessName: '事業名',
        businessNamePlaceholder: '事業名',
        name: '名前',
        phone: '電話番号',
        email: 'メールアドレス',
        businessNumber: '事業者番号',
        taxNo: '税番号 N°',
        deleteField: '削除',
        addNewField: '新しい項目を追加',
        address: '住所',
        line1: '住所1',
        line2: '住所2',
        line3: '住所3',
        currency: '通貨',
        currencyLabel: '通貨',
        symbol: '記号',
        placement: '配置',
        before: '前',
        after: '後',
        thousandSymbol: '桁区切り記号',
        decimalSymbol: '小数点記号',
        decimalPlaces: '小数点以下の桁数',
        example: '例',
        terms: '支払条件',
        termsLabel: '支払条件',
        termSameDay: '当日',
        term7Days: '7日',
        term14Days: '14日',
        term21Days: '21日',
        term30Days: '30日',
        term45Days: '45日',
        term60Days: '60日',
        term90Days: '90日',
        term180Days: '180日',
        term365Days: '365日',
        paymentInfo: '支払い情報',
        displayOnInvoices: '請求書に表示',
        titlePlaceholder: 'タイトル',
        jobDetails: 'ジョブ詳細',
        deleteJobDetail: '削除',
        addNewJobField: '新しい項目を追加',
        fieldNameRequired: '{field}：フィールド名は必須です',
        reservedCharacters: '{field}：フィールド名に : または &&、値に && は使用できません',
        serializedDataTooLong: '{field}のデータがデータベースの上限を超えています',
        textDataTooLong: '{field}がデータベースの上限を超えています'
    },
    default: {
        title: 'デフォルト',
        emailMessage: 'メールメッセージ',
        enterDescription: '説明を入力',
        emailCc: 'メール Cc',
        emailBcc: 'メール Bcc',
        emailTip: '上記のアドレスにも同時にメールを送信します。',
        defaultComments: 'デフォルトコメント',
        invoice: '請求書',
        estimate: '見積書',
        purchaseOrder: '発注書',
        creditMemo: 'クレジットメモ',
        emailValidError: 'メールアドレスが有効です'
    },
    invoiceDesign: {
        template: 'テンプレート',
        color: 'カラー',
        labels: 'ラベル',
        labelInvoice: '請求書',
        labelEstimate: '見積書',
        labelPurchaseOrder: '発注書',
        labelCreditMemo: 'クレジットメモ',
        labelReceipt: '領収書',
        labelTermsFormat: '支払条件の書式',
        labelBillTo: '請求先',
        labelFor: '宛先',
        labelDate: '日付',
        labelInvoiceNo: '請求書番号',
        labelEstimateNo: '見積書番号',
        labelPoNo: '発注書番号',
        labelCreditMemoNo: 'クレジットメモ番号',
        labelDueDate: '支払期限',
        labelTerms: '支払条件',
        labelAmount: '金額',
        labelCode: 'コード',
        labelDescription: '説明',
        labelQuantity: '数量',
        labelRate: '単価',
        labelTax: '税金',
        labelSubtotal: '小計',
        labelBalanceDue: '未払残高',
        labelDiscount: '割引',
        labelNonTaxableItem: '非課税アイテム',
        labelPaid: '支払済み',
        labelShipping: '配送',
        labelTotal: '合計',
        labelIncludes: '内訳',
        labelTotalAmountPaid: '支払済総額',
        labelShipDate: '発送日',
        labelShipTo: '配送先',
        labelShipVia: '配送業者',
        labelTrackingNo: '追跡番号',
        labelFob: 'F.O.B',
        prefix: 'プレフィックス',
        prefixInvoice: '請求書',
        prefixEstimate: '見積書',
        prefixPurchaseOrder: '発注書',
        prefixCreditMemo: 'クレジットメモ',
        nextNumber: '次の番号',
        numberingBeginsAt: '番号の開始',
        nextNumberInvoice: '請求書',
        nextNumberEstimate: '見積書',
        nextNumberPurchaseOrder: '発注書',
        nextNumberCreditMemo: 'クレジットメモ',
        options: 'オプション',
        optionTerms: '支払条件',
        optionDueDate: '支払期限',
        optionShippingAddress: '配送先住所',
        optionProductCode: '商品コード',
        optionQuantityAndRate: '数量と単価',
        optionUnit: '単位',
        optionTax: '税金',
        optionAmount: '金額',
        optionNonTaxableItemStar: '非課税アイテムの印',
        optionDiscount: '割引を表示',
        optionTaxBreakdown: '税金内訳',
        optionPaymentHistory: '支払い履歴',
        optionStamp: 'スタンプ',
        optionPageNumber: 'ページ番号',
        previewName: 'Robin',
        previewAddress: '726 Building St. #872',
        previewCity: 'Seattle,Washington',
        previewZip: '99999 US',
        previewDate: 'Oct 1,2019',
        previewShipName: 'Peter',
        previewShipDate: 'Oct 2,2019',
        previewShipVia: 'Federal Express',
        previewThanksMessage: "お取引ありがとうございます！私たちのサービスにご満足いただけたでしょうか。15日以内にお支払いください。ご質問やご意見はこちらまで：(111)111-1234、または example@owner.com までメールにてお問い合わせください。どんなご質問にも喜んでお答えいたします。",
        previewSubtotal: '小計',
        previewVat: 'VAT 17.00%',
        previewPayment1: '10月1日の支払い 2019',
        previewPayment2: '10月2日の支払い 2019',
        invalidNextNumber: '各次回番号は 0 から {max} までの整数で入力してください'
    },
    feedback: {
        title: 'フィードバックを送信',
        invalidEmailNoticePrefix: 'アカウントのメールアドレスが無効なため、ご連絡できませんでした。有効なメールアドレスからフィードバックをお送りください:',
        invalidEmailNoticeSuffix: '可能であれば、問題のスクリーンショットを添付してください。調査と解決に役立ちます。',
        replyTip: '送信後、返信はメールにてご確認ください。',
        contextTip: '次のアカウントとブラウザー情報がフィードバックに含まれます：',
        content: '内容',
        enterDescription: '説明を入力',
        contentTooLong: '内容は {max} 文字以内で入力してください'
    },
    createExpense: {
        title: '経費を追加',
        description: '説明',
        expenseDescriptionPlaceholder: '経費の説明',
        total: '合計',
        tax: '税金',
        tip: 'チップ',
        expenseDate: '経費日',
        merchant: '加盟店',
        merchantPlaceholder: '加盟店名を入力',
        categoryPlaceholder: 'カテゴリーを選択',
        addNewCategory: '新しいカテゴリーを追加',
        deletePhoto: '削除',
        addPhoto: '写真を追加',
        deleteCategory: '削除',
        addCategory: 'カテゴリーを追加',
        descriptionTooLong: '説明は3,000文字以内で入力してください。',
        merchantTooLong: '店舗名は255文字以内で入力してください。',
        amountInvalid: '合計、税金、チップはそれぞれ0から999999999999999の範囲で、小数点以下5桁以内にしてください。',
        categoryRequired: 'カテゴリー名を入力してください。',
        categoryTooLong: 'カテゴリー名は255文字以内で入力してください。',
        photoUploadFailed: '写真をアップロードできませんでした。もう一度お試しください。'
    },
    updateExpense: {
        title: '経費を更新',
        deleteExpense: '経費を削除',
        confirmDeleteMsg: 'この経費が削除されます。続行しますか？'
    },
    notFound: {
        oops: 'おっと！',
        notFoundMsg: 'お探しのページが見つかりません。',
        takeMeHome: 'ホームに戻る'
    },
    classicPDF: {
        previewName: 'Robin',
        previewAddress: '726 Building St. #872',
        previewCity: 'Seattle,Washington',
        previewZip: '99999 US',
        previewDate: 'Oct 1,2019',
        previewDueDate: 'Nov 15,2019',
        previewShipName: 'Peter',
        previewFreeShipping: '無料配送',
        previewShipDate: 'Oct 2,2019',
        previewShipVia: 'Federal Express',
        previewItem1: 'コンピューター',
        previewItem2: '電話',
        previewItem3: 'バースデーケーキ',
        previewTaxRate: '17%',
        nonTaxableNote: '* 非課税アイテムを示します',
        thanksMessage: "お取引ありがとうございます！私たちのサービスにご満足いただけたでしょうか。15日以内にお支払いください。ご質問やご意見はこちらまで：(111)111-1234、または example@owner.com までメールにてお問い合わせください。どんなご質問にも喜んでお答えいたします。",
        subtotal: '小計',
        vat: 'VAT 17.00%',
        payment1: '10月1日の支払い 2019',
        payment2: '10月2日の支払い 2019',
        balanceDue: '未払残高'
    }
};
